
var ZVA_KEY  = "XNpMRQ";
var ZVA_TEXT = {
  'not-for-me':    'It probably wasn’t right for my skin',
  'they-oversold': 'They oversold it',
  'blame-self':    'I should have known better',
  'never-knew':    'I never really found out'
};

function zvaEl(id){ return document.getElementById(id); }
function zvaEsc(s){
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function zvaParam(n){
  try {
    var m = new RegExp('[?&]' + n + '=([^&#]*)').exec(window.location.search);
    if (!m) return '';
    return decodeURIComponent(m[1].replace(/\+/g, ' ')).trim();
  } catch (e) { return ''; }
}
function zvaValidEmail(e){ return !!e && e.indexOf('@') > 0 && e.lastIndexOf('.') > e.indexOf('@'); }

/* Writes the property. /client/profiles/ is the only endpoint that sets custom
   properties on a profile that ALREADY exists — /client/subscriptions/ returns 202
   and writes nothing (proven 2026-08-11). This page only ever touches existing
   waitlist profiles, so profiles/ is the call that matters. */
function zvaWrite(email, answer){
  var body = {
    data: {
      type: 'profile',
      attributes: {
        email: email,
        properties: {
          failure_attribution: answer,
          failure_attribution_at: new Date().toISOString()
        }
      }
    }
  };
  return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + ZVA_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    throw new Error('profiles ' + r.status);
  });
}

function zvaThanks(answer){
  var line = ZVA_TEXT[answer] || '';
  var h = '<div class="zv-card">';
  h += '<h2 class="zv-h">Got it. Thank you.</h2>';
  if (line) h += '<div class="zv-echo">' + zvaEsc(line) + '</div>';
  h += '<p>Your answer request was received. Nothing else happens because of it — no extra emails, no offer coming your way.</p>';
  h += '<p>I asked because I genuinely don’t know the answer. Whether women walk away from a product blaming the bottle or blaming themselves changes how I ought to write about this, and guessing would be the lazy option.</p>';
  h += '<p class="zv-soft">You can close this now.</p>';
  h += '</div>';
  zvaEl('zvaStage').innerHTML = h;
}

function zvaAsk(prefillEmail, note){
  var h = '<div class="zv-card">';
  h += '<h2 class="zv-h">When a product didn’t work, what did you end up thinking?</h2>';
  if (note) h += '<p class="zv-soft">' + zvaEsc(note) + '</p>';
  h += '<p class="zv-soft">Your email, so the answer lands on the record you already have.</p>';
  h += '<input type="email" class="zv-input" id="zvaEmail" placeholder="Your email address" autocomplete="email" inputmode="email" value="' + zvaEsc(prefillEmail || '') + '">';
  for (var k in ZVA_TEXT) {
    if (ZVA_TEXT.hasOwnProperty(k)) {
      h += '<button type="button" class="zv-opt" onclick="zvaPick(\'' + k + '\')">' + zvaEsc(ZVA_TEXT[k]) + '</button>';
    }
  }
  h += '<div class="zv-msg" id="zvaMsg"></div>';
  h += '</div>';
  zvaEl('zvaStage').innerHTML = h;
}

function zvaPick(answer){
  var em = zvaEl('zvaEmail') ? zvaEl('zvaEmail').value.trim() : '';
  var m  = zvaEl('zvaMsg');
  if (!zvaValidEmail(em)) { if (m) m.textContent = 'Please enter the email address you signed up with.'; return; }
  if (m) m.textContent = '';
  zvaSend(em, answer);
}

function zvaSend(email, answer){
  zvaEl('zvaStage').innerHTML = '<div class="zv-card"><p class="zv-soft">One moment…</p></div>';
  zvaWrite(email, answer).then(function(){
    zvaThanks(answer);
  }).catch(function(){
    zvaAsk(email, 'Something went wrong saving that. Please try once more.');
  });
}

(function(){
  var a = zvaParam('a');
  var e = zvaParam('e');
  if (ZVA_TEXT.hasOwnProperty(a) && zvaValidEmail(e)) { zvaAsk(e, 'Choose your answer below to save it.'); return; }
  if (ZVA_TEXT.hasOwnProperty(a)) { zvaAsk('', 'One thing first — the link didn’t carry your email address across.'); return; }
  zvaAsk(e, '');
})();
